import { Injectable, Injector } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import * as uuid from 'uuid';
import { setStorage, getStorage} from '../utilities';

import { BaseComponents } from '../../base.component';

@Injectable({
  providedIn: 'root'
})
export class LogService extends BaseComponents{

  constructor(
    protected injectorObj:Injector,
    //private logger: NGXLogger
  ) {
    super(injectorObj);
  }
  
  setupLogger(){
    const trackingID:string = getStorage('logger_tracking')
    if(trackingID){
      this.logger.setCustomHttpHeaders(new HttpHeaders({ 'logger_tracking': trackingID}))
    }else{
      const newTrackingID:string =  uuid.v4() + Date.now();
      this.logger.setCustomHttpHeaders(new HttpHeaders({ 'logger_tracking': newTrackingID }))
      setStorage('logger_tracking', newTrackingID);
    }

  }
}
